// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.left-aligned {
  text-align: left !important;
}

.left-aligned * {
  text-align: left !important;
}

.left-aligned h4 {
  text-align: left !important;
}

.left-aligned input {
  text-align: left !important;
}

.left-aligned textarea {
  text-align: left !important;
}

.left-aligned label {
  text-align: left !important;
}

.left-aligned div {
  text-align: left !important;
}

/* Force left alignment for Epic form specifically */
.epic-form-container * {
  text-align: left !important;
}

.epic-form-container h4 {
  text-align: left !important;
  justify-self: flex-start !important;
}

.epic-form-container .story-title {
  text-align: left !important;
  align-self: flex-start !important;
  margin-right: auto !important;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oDAAoD;AACpD;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.left-aligned {\n  text-align: left !important;\n}\n\n.left-aligned * {\n  text-align: left !important;\n}\n\n.left-aligned h4 {\n  text-align: left !important;\n}\n\n.left-aligned input {\n  text-align: left !important;\n}\n\n.left-aligned textarea {\n  text-align: left !important;\n}\n\n.left-aligned label {\n  text-align: left !important;\n}\n\n.left-aligned div {\n  text-align: left !important;\n}\n\n/* Force left alignment for Epic form specifically */\n.epic-form-container * {\n  text-align: left !important;\n}\n\n.epic-form-container h4 {\n  text-align: left !important;\n  justify-self: flex-start !important;\n}\n\n.epic-form-container .story-title {\n  text-align: left !important;\n  align-self: flex-start !important;\n  margin-right: auto !important;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 0.2;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
